import delegate from "delegate-it";
import ajax from "@/scripts/common/ajax";
import { scrollToIfNeeded } from "@/scripts/common/scroll-to";
import { generateQueryString, updateQueryParams } from "@/scripts/common/util";

const placeholderImage = document.querySelector(".placeholder-image");
const patternImageHolder = document.querySelector(".pattern-image-holder");
const patternImageHolderNoImage = document.querySelector(".pattern-image-holder-no-image");
const form = document.querySelector(".filter-form");

const updateResults = async () => {
  const pageContent = document.querySelector("[data-page-content]");

  pageContent.classList.add("is-loading");

  const res = await ajax.get(window.location.href).json();

  pageContent.innerHTML = res.page;
  pageContent.classList.remove("is-loading");

  if (res.isFiltered) {
    scrollToIfNeeded(pageContent, 24);
  }
};

const handleFilter = (e) => {
  let url;

  if (e.target.tagName === "SELECT") {
    url = updateQueryParams([
      [e.target.name, e.target.value],
      ["search", false],
    ]);
  } else {
    handleSearch();

    return;
  }

  window.history.replaceState({}, "", url);

  updateResults();
};

const handleSearch = () => {
  const data = new FormData(form);

  const search = data.get("search");

  if (search) {
    const queryString = generateQueryString({ search });
    const url = queryString.size ? `${form.action}?${queryString}` : form.action;

    window.history.replaceState({}, "", url);

    updateResults();
  }
};

const handleSubmit = (e) => {
  e.preventDefault();

  handleSearch();
};

const handleFilterClear = (e) => {
  e.preventDefault();

  const url = updateQueryParams(false);
  window.history.replaceState({}, "", url);

  updateResults();
};

const handleArticleHover = (e) => {
  const item = e.delegateTarget;

  if (item.dataset.image) {
    const img = document.createElement("img");
    img.src = item.dataset.image;
    img.classList.add("object-cover", "absolute", "inset-0", "w-full", "h-full");

    patternImageHolder.innerHTML = null;
    patternImageHolder.appendChild(img);
    patternImageHolder.setAttribute("aria-hidden", "false");

    patternImageHolderNoImage.innerHTML = null;
    patternImageHolderNoImage.setAttribute("aria-hidden", "true");

    placeholderImage.style.visibility = "hidden";
  } else if (item.dataset.placeholderImage) {
    const img = document.createElement("img");
    img.src = item.dataset.placeholderImage;
    img.classList.add("object-cover", "absolute", "inset-0", "w-full", "h-full", "blend-image-blue");

    patternImageHolder.innerHTML = null;
    patternImageHolder.setAttribute("aria-hidden", "true");

    patternImageHolderNoImage.innerHTML = null;
    patternImageHolderNoImage.appendChild(img);
    patternImageHolderNoImage.setAttribute("aria-hidden", "false");

    placeholderImage.style.visibility = "hidden";
  } else {
    patternImageHolder.innerHTML = null;
    patternImageHolder.setAttribute("aria-hidden", "true");

    patternImageHolderNoImage.innerHTML = null;
    patternImageHolderNoImage.setAttribute("aria-hidden", "true");

    placeholderImage.style.visibility = "visible";
  }
};

document.addEventListener("DOMContentLoaded", () => {
  if (form) {
    delegate(".filter-form", "change", handleFilter);
    delegate(".filter-form", "submit", handleSubmit);
    delegate(".filter-form-clear", "click", handleFilterClear);
    delegate(".article-item", "mouseover", handleArticleHover);
    delegate(".articles-list", "mouseout", handleArticleHover);
  }
});
